import React from 'react';

import { MessageWrap } from './DateMessageItem.style';
import { IDateMessageItem } from './IDateMessageItem';

export const DateMessageItem = ({ date }: IDateMessageItem) => (
  <MessageWrap>{date}</MessageWrap>
);
